import React, { useEffect } from 'react'
import CurrencyInfo from './CurrentInformation'
import styles from './viewCurrency.module.sass'
import { ToastContainer } from 'react-toastify'

const ViewCurrency = ({isChanged, setIsChanged}) => {
  
  return (
    <>
      <ToastContainer />
      <div className={styles.row}>
        <div className={styles.col}>
          <CurrencyInfo isChanged={isChanged} setIsChanged={setIsChanged} className={styles.card}/>
        </div>
      </div>
    </>
  )
}

export default ViewCurrency